const release = '1.15.4'

module.exports = release



//////////////////
// WEBPACK FOOTER
// ./release.js
// module id = immm
// module chunks = 1624